export const getAutoListErrorMessage = (tags: string[] = []): string => {
  if (tags?.some(t => t.toLowerCase() === 'no size'))
    return 'Size information is missing — please update and try again.'
  if (tags?.some(t => t.toLowerCase() === 'split-lot')) return 'Item is a split lot — please update and try again.'
  if (tags?.some(t => t.toLowerCase() === 'counterfeit'))
    return 'Potential counterfeit detected — please review and try again.'
  return 'Auto-listing paused — edit this product to continue.'
}
